module.exports = __webpack_public_path__ + "static/media/homework-success-banner.0bd68b62.png";